"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Loader_1 = require("../../Indicators/Loader");
var Localization_1 = require("../../Localization");
var TileBase_styles_1 = require("./TileBase.styles");
var TileHeaderAndArticle = function (_a) {
    var HeaderContent = _a.HeaderContent, Loading = _a.Loading, AlignContent = _a.AlignContent, NoContentPadding = _a.NoContentPadding, children = _a.children;
    return (React.createElement(React.Fragment, null,
        React.createElement(TileBase_styles_1.Header, null, HeaderContent()),
        React.createElement(TileBase_styles_1.Line, null),
        React.createElement("div", null,
            React.createElement(TileBase_styles_1.Article, { AlignContent: Loading ? "center" : AlignContent ? AlignContent : "start", NoPadding: NoContentPadding }, Loading ?
                React.createElement(Loader_1.AreaLoader, { Caption: Localization_1.strings.Label_Loading })
                :
                    React.createElement(React.Fragment, null, children)))));
};
exports.default = TileHeaderAndArticle;
